import { useState } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Radio, RadioGroup } from "@nextui-org/react";

import { useCreateQuizOptions } from "../hooks/useCreateQuizOptions";

import Input from "../../../../components/input/Input";
import Button from "../../../../components/Button";

function CreateOption() {
    const [isCorrect, setIsCorrect] = useState();

    const { register, handleSubmit, reset } = useForm();

    const { courseId, lectureId, itemId, questionId } = useParams();
    const {
        createQuizOptions,
        isCreating,
        error: ApiError,
    } = useCreateQuizOptions();

    function onSubmit({ option }) {
        //Send The Form Data To The API
        createQuizOptions(
            {
                courseId,
                lectureId,
                itemId,
                questionId,
                option,
                is_correct: isCorrect,
            },
            {
                onSuccess: () => {
                    reset();
                },
            }
        );
    }

    return (
        <>
            <h3 className="py-5 text-xl text-center text-blue-color-primary">
                إضافة اختيار
            </h3>

            <form onSubmit={handleSubmit(onSubmit)} className="pb-4">
                <Input
                    label={`الاختيار `}
                    name={`option`}
                    type="text"
                    size="fullWidth"
                    register={register("option", {
                        required: "برجاء ادخال الأختيار",
                    })}
                    error={ApiError?.response?.data?.errors?.option?.[0]}
                    disabled={isCreating}
                />
                <RadioGroup
                    orientation="horizontal"
                    value={isCorrect}
                    onValueChange={setIsCorrect}
                    color="primary"
                    className="py-5"
                >
                    <Radio value={true}>صحيح</Radio>
                    <Radio value={false}>خاطئ</Radio>
                </RadioGroup>
                <div className="w-full pt-3">
                    <Button
                        type="primary"
                        className="w-full leading-8 rounded-lg"
                        disabled={isCreating}
                    >
                        إضافة اختيار
                    </Button>
                </div>
            </form>
        </>
    );
}

export default CreateOption;
